import { produce } from 'immer'
import Actions from '../actions'
import { dateFormat, relationship } from '../consts'
import { v4 as uuidv4 } from 'uuid'
import dayjs from 'dayjs'
import { getOEPCoverageDate } from 'utils/generalUtils'

const memberInitialInfo = {
  id: uuidv4(),
  dob: null,
  sex: '',
  isTobbacoUser: false,
  isElligible: false,
  email: null,
  relation: relationship.owner,
  isMailingAddressAsHomeAddress: true,
  homeAddress: {
    state: null,
    zipCode: null,
    county: null,
    city: null,
    address1: null,
    address2: null
  },
  mailingAddress: null
}

const familyMemberInitialInfo = {
  ...memberInitialInfo,
  relation: null,
  isHomeAddressAsOwner: true,
  isMailingAddressAsOwner: true
}

const initialState = {
  members: [{ ...memberInitialInfo }],
  memberQualifyLifeEvent: {
    reason: null,
    date: null,
    coverageStartDate: null
  },
  isZipCodeValidating: false,
  countyList: [],
  zipCodeValidationStatus: null
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.MEMBER_INFO_CHANGED: {
      const memberIndex = draft.members?.findIndex(
        member => member.id === payload?.id
      )
      draft.members[memberIndex][payload?.key] = payload?.value
      break
    }
    case Actions.MEMBER_CHANGED: {
      draft.members = draft.members?.map(member => {
        if (member.id === payload?.id) return payload
        return member
      })
      break
    }
    case Actions.ADD_MEMBER: {
      const cloneFamilyMembers = [...draft.members]
      cloneFamilyMembers.push({ ...familyMemberInitialInfo, id: uuidv4() })
      draft.members = cloneFamilyMembers
      break
    }
    case Actions.REMOVE_MEMBER: {
      draft.members = draft.members?.filter(member => member.id !== payload?.id)
      break
    }
    case Actions.QUALIFY_LIFE_EVENT_LOADED: {
      draft.memberQualifyLifeEvent = payload
      break
    }
    case Actions.AUTO_FILL_QUALLIFY_LIFE_EVENT:
    case Actions.MEMBER_QUALIFY_LIFE_EVENT_CHANGED: {
      draft.memberQualifyLifeEvent = payload
      break
    }
    case Actions.AUTO_FILL_ENROLLEES: {
      draft.members = [{ ...draft.members?.[0], ...payload }]
      break
    }
    case Actions.MEMBERS_UPDATED: {
      // attention: ssn will be cleared,
      draft.members = payload
      break
    }
    case Actions.UPDATE_OWNER_MEMBER_EMAIL: {
      const ownerIndex = draft.members?.findIndex(
        member => member.relation === relationship.owner
      )
      draft.members[ownerIndex].email = payload?.email
      break
    }
    case Actions.VALIDATE_ZIP_CODE_REQUESTED: {
      draft.isZipCodeValidating = true
      break
    }
    case Actions.VALIDATE_ZIP_CODE_RECEIVED: {
      draft.isZipCodeValidating = false
      const memberIndex = draft.members?.findIndex(
        member => member.id === payload?.memberId
      )
      const data = payload?.data
      draft.members[memberIndex].homeAddress.county = data?.selectedCounty
      draft.countyList = data?.countyList
      draft.zipCodeValidationStatus = payload?.status
      break
    }
    case Actions.UPDATE_ZIP_CODE: {
      const memberIndex = draft.members?.findIndex(
        member => member.id === payload?.memberId
      )
      draft.members[memberIndex].homeAddress.zipCode = payload?.zipcode
      draft.members[memberIndex].homeAddress.county = null
      draft.zipCodeValidationStatus = null
      draft.countyList = []
      break
    }
    case Actions.UPDATE_COUNTY: {
      const memberIndex = draft.members?.findIndex(
        member => member.id === payload?.memberId
      )
      draft.members[memberIndex].homeAddress.county = payload?.county
      break
    }
    case Actions.AUTO_FILL_ZIP: {
      const data = payload?.data
      draft.zipCodeValidationStatus = payload?.status
      draft.members[0].homeAddress.zipCode = data.zipCode
      draft.members[0].homeAddress.county = data.selectedCounty
      draft.countyList = data.countyList
      break
    }
    case Actions.OEP_DETECTED: {
      const coverageDate = getOEPCoverageDate(payload?.appConfig?.config)
      draft.memberQualifyLifeEvent.coverageStartDate =
        dayjs(coverageDate).format(dateFormat)
      break
    }
    case Actions.OPERATION_FAILED: {
      draft.isZipCodeValidating = false
      break
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
